var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGradientBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 1152,
    viewBox: "0 0 1152 1152",
    preserveAspectRatio: "xMinYMin",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(NaN 576 576) translate(576 576) scale(NaN) translate(-576 -576) translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(1 1) translate(0 0)"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    width: 1152,
    height: 1152,
    viewBox: "0 0 1152 1152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      overflow: "visible"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 356,
    width: 440,
    height: 440,
    rx: 24,
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 356,
    width: 440,
    height: 440,
    rx: 24,
    fill: "url(#paint1_radial)",
    fillOpacity: 0.78
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 356,
    width: 440,
    height: 440,
    rx: 24,
    fill: "url(#paint2_radial)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 356,
    width: 440,
    height: 440,
    rx: 24,
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356,
    y: 356,
    width: 440,
    height: 440,
    rx: 24,
    fill: "url(#paint4_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0,
    y: 0,
    width: 1152,
    height: 1152,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 178,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 796,
    y1: 787.5,
    x2: 229,
    y2: 258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3D0B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(771 771.5) rotate(-134.198) scale(353.588 681.193)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.322917,
    stopColor: "#0B3D0B",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.640625,
    stopColor: "#0B3D0B",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3D0B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(510.5 307.5) rotate(82.4148) scale(200.757)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3D0B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 367.5,
    y1: 784.5,
    x2: 649.5,
    y2: 695.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3D0B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(775 382.5) rotate(124.873) scale(335.804)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0B3D0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.547057,
    stopColor: "#0B3D0B",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0B3D0B",
    stopOpacity: 0
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientBlob);
export default __webpack_public_path__ + "static/media/gradient-blob.393946223e8e9b3968b8cb4bebbb6700.svg";
export { ForwardRef as ReactComponent };